<h2 mat-dialog-title class="tw-m-0 tw-text-lg tw-font-semibold">Bullets</h2>
<div
  appGlossScroll
  mat-dialog-content
  class="tw-max-h-[70vh] tw-overflow-y-auto tw-min-w-[min(92vw,28rem)] tw-text-dt-text-headings"
>
  <ul class="tw-list-disc tw-pl-5 tw-space-y-3 tw-text-sm tw-m-0 tw-pb-2">
    <li>
      By default, when checking for dedup,
      <span class="tw-font-mono tw-text-xs">dateModified</span>,
      <span class="tw-font-mono tw-text-xs">dateCreated</span>,
      <span class="tw-font-mono tw-text-xs">vaultId</span>, and item
      <span class="tw-font-mono tw-text-xs">id</span>
      are not included. That means even if these props differ, if the rest matches the items are
      considered duplicates.
    </li>
    <li>
      If you want to include <span class="tw-font-mono tw-text-xs">id</span> for dedup, check the
      relative checkbox (<strong>Include id for dedup</strong>).
    </li>
    <li>
      Any duplicate found while <span class="tw-font-mono tw-text-xs">id</span> is included is safe
      to be deleted.
    </li>
    <li>
      For source transactions: if they seem duplicate with the id-checkbox unchecked, click
      <strong>Show all</strong> and check whether
      <span class="tw-font-mono tw-text-xs">srId</span>
      is the same for the listed items—if so, there are multiple sources for the same transaction.
      You can delete the duplicates.
    </li>
    <li>For any other suggestions, misunderstandings, etc., reach out to Sinan.</li>
  </ul>
</div>
<div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
